import PmcBridge from 'shared/services/pmc-bridge'

export default class PushMagazine {
	private pushMagazine: HTMLElement | null
	private subscribeCta: HTMLElement | null | undefined
	private previewCta: HTMLElement | null | undefined
	private readMagazineCta: HTMLElement | null | undefined
	private PMCBridge: PmcBridge
	private isUserSubscribed: boolean

	constructor() {
		this.pushMagazine = document.querySelector('.pushMagazine')
		this.subscribeCta = this.pushMagazine?.querySelector('[data-subscribe-cta]')
		this.previewCta = this.pushMagazine?.querySelector('[data-preview-cta]')
		this.readMagazineCta = this.pushMagazine?.querySelector('[data-read-magazine-cta]')
		this.PMCBridge = new PmcBridge()
		this.isUserSubscribed = false
	}

	async init() {
		this.initPreviewCta()

		const isConnected = await this.PMCBridge.isConnected()
		if (isConnected === true && this.readMagazineCta) {
			this.contextualizeForConnectedUser()
			return
		}

		if (!this.subscribeCta) return

		this.isUserSubscribed = await this.PMCBridge.hasSubscription()
		if (this.isUserSubscribed) {
			this.hideSubscribeCta()
		}
	}

	private initPreviewCta() {
		if (!this.previewCta) return

		const titleId = this.previewCta.dataset.titleId
		if (!titleId) return

		this.previewCta.addEventListener('click', async (event) => {
			event.preventDefault()
			const newTab = window.open('about:blank', '_blank')

			try {
				const response = await fetch(
					`https://shop.prismamedia.com/api/v2/shop/magazine_title_taxon/${titleId}/preview`
				)
				if (!response.ok) {
					newTab?.close()
					return
				}

				const data = (await response.json()) as { url?: string }
				if (data?.url && typeof data.url === 'string') {
					if (newTab) {
						newTab.location.href = data.url
					} else {
						window.open(data.url, '_blank', 'noopener,noreferrer')
					}
				} else {
					newTab?.close()
				}
			} catch {
				newTab?.close()
			}
		})
	}

	private hideSubscribeCta() {
		this.subscribeCta?.classList.add('hidden')
	}

	private contextualizeForConnectedUser() {
		this.readMagazineCta?.classList.remove('hidden')
		this.previewCta?.classList.add('hidden')
		this.subscribeCta?.classList.add('hidden')
	}
}
